/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable react/no-unsafe */
import { Component } from 'react'

import { Swipeable } from '@skytech/ui'
// @ts-ignore
import sort, { ASC } from 'sort-array-objects'

import { getSalaryDeductionList } from '@/api/salaryDeduction'
import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import Usage from '@/components/util/Usage'
import { withNavigation } from '@/hocs/withNavigation'
import { getMonthName } from '@/util/formatters/dates'

import { Translation } from '../i18n/Translation'

import './style/invoice-list.scss'

class InvoiceList extends Component<any> {
  // @ts-ignore
  constructor(props) {
    super(props)
    // @ts-ignore
    this.priceTypes = {
      T: 'Bruk',
      Q: 'Bruk',
      S: 'Abonnement',
      O: 'Engangsavgifter',
      D: 'Bruk',
      0: '?',
    }
    this.state = {
      invoiceRows: [],
      CDRs: [],
      visible: false,
      animate: true,
      loading: false,
      invoice: null,
    }
  }

  componentDidMount = () => {
    if (this.props.active) {
      this.loadInvoice()
    }
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps = (nextProps: unknown) => {
    // @ts-ignore
    if (nextProps.active) {
      this.loadInvoice()
    }
  }

  loadInvoice = () => {
    const invoice = this.props.currentInvoice
    this.setState({
      invoiceRows: [],
      animate: true,
      visible: true,
      loading: true,
    })

    getSalaryDeductionList({ invoiceId: invoice.id, phoneNumber: this.props.user.code })
      .then(result => {
        // @ts-ignore
        const posts = []
        // @ts-ignore
        result.invoiceContent.forEach(item => {
          posts.push(item)
        })
        this.setState({
          // @ts-ignore
          invoiceRows: [...posts],
          // @ts-ignore
          CDRs: [...result.CDRs],
          loading: false,
          invoice: { ...invoice },
        })
      })
      .catch(() => {})
  }

  refresh = () => {
    this.loadInvoice()
  }
  // @ts-ignore
  postHeader(display, item) {
    if (!display) return null
    return (
      <div className="post_header">
        <Translation id={item.price_type_text} />
      </div>
    )
  }

  getPosts = () => {
    // @ts-ignore
    let posts = sort([...this.state.invoiceRows], ['product'], ASC)

    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < posts.length; i++) {
      // @ts-ignore
      posts[i].price_type_text = this.priceTypes[posts[i].price_type]
    }

    // @ts-ignore
    posts = sort([...this.state.invoiceRows], ['price_type_text'], ASC)

    // @ts-ignore
    let prev_price_type = null

    // @ts-ignore
    return posts.map(item => {
      // @ts-ignore
      const header = prev_price_type !== item.price_type_text
      prev_price_type = item.price_type_text

      return (
        <div className="post" key={item.id}>
          {this.postHeader(header, item)}
          <div className="post_content">
            <span className="nbr">
              <FormattedNumberWithCurrency amount={item.vat + item.amount} precision={2} />
            </span>
            <span className="product">
              {item.product}
              <br />
              <Usage item={item} />
            </span>
          </div>
        </div>
      )
    })
  }

  hide = () => {
    this.props.navigate('/dashboard/' + this.props.offset)
    this.setState({
      visible: false,
      applicationMode: false,
    })
  }

  render() {
    let classNames = [this.props.active ? 'is-visible' : 'is-hidden']

    // @ts-ignore
    if (this.state.animate) {
      classNames.push('animate')
    }

    const content = (
      <div className="contentWrapper">
        <div className="invoice-header">
          <h1>
            {/* @ts-ignore */}
            {this.state.invoice ? <Translation id={getMonthName(this.state.invoice.date)} /> : ''}
          </h1>
          <h2>
            {/* @ts-ignore */}
            {this.state.invoice ? 'Faktnr: ' + this.state.invoice.invoice_no : ''}
          </h2>
        </div>
        <div className="posts">
          {this.getPosts()}
          <div className="post" key={0}>
            <div className="post_header">
              <Translation id="Sum" />
            </div>
            <div className="post_content">
              <span className="nbr sum">
                <FormattedNumberWithCurrency
                  amount={
                    // @ts-ignore
                    this.state.invoice ? this.state.invoice.amount + this.state.invoice.vat : 0
                  }
                  precision={2}
                />
              </span>

              <span className="product sum">&nbsp;</span>
            </div>
          </div>
        </div>
      </div>
    )

    const loader = (
      <div className="invoice-header">
        <div className="loader dark" />
      </div>
    )
    const whiteLabel = localStorage.getItem('org')

    return (
      <Swipeable
        id="invoice-list"
        className={[...classNames, whiteLabel].join(' ')}
        onSwipedRight={this.hide}
      >
        {/* @ts-ignore */}
        {this.state.loading ? loader : content}
      </Swipeable>
    )
  }
}

export default withNavigation(InvoiceList)
